<template>
  <div>
    <div class="mt-12 mb-4 d-flex">
      <h1 class="ang-heading">Formularz rejestracji leada ANG</h1>
    </div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <div
      v-if="sent"
      class="text-xs font-semibold py-5 px-5 uppercase rounded text-green-600 bg-green-200 uppercase last:mr-0 mr-1 mt-2"
    >
      Dziękujemy za poprawne uzupełnienie formularza
    </div>
    <div class="ang-card" v-show="!loading">
      <form
        v-if="!sent"
        id="platformaMieszkaniowaLeadForm"
        ref="platformaMieszkaniowaLeadForm"
        method="POST"
        class="ang-card-body"
        action="/lead"
      >
        <input type="hidden" name="public_form" value="1" />

        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="first_name">Imię</label>
              <input
                type="text"
                class="ang-form-control"
                id="first_name"
                name="first_name"
                required
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="last_name">Nazwisko</label>
              <input
                type="text"
                class="ang-form-control"
                id="last_name"
                name="last_name"
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email">Adres e-mail</label>
              <input
                type="email"
                class="ang-form-control"
                id="email"
                name="email"
                required
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email"
                >Powtórz adres e-mail</label
              >
              <input
                type="email"
                class="ang-form-control"
                id="email_confirmation"
                equaltoignorecase="#email"
                name="email_confirmation"
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="row form-group">
              <div class="col-12">
                <label class="ang-form-label" for="email">Numer telefonu</label>
                <input
                  type="text"
                  class="ang-form-control dig"
                  name="phone"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="ang-form-label" for="email"
                >Preferowane miasto obsługi</label
              >
              <input
                type="text"
                class="ang-form-control"
                id="city"
                name="city"
                required
              />
            </div>
          </div>
        </div>
        <div class="row">
          <input
            type="hidden"
            name="lead_partner_uid"
            value="183c8f8e-0b44-4188-88da-421170e5d100"
          />
          <input
            type="hidden"
            name="source_uid"
            value="81da1d25-0d1b-11ef-97df-8ea11ed63f6f"
          />
          <div class="col-12">
            <div class="form-group">
              <label class="ang-form-label" for="ref"
                >Dane Pośrednika - imię, nazwisko, nr tel, adres email</label
              >
              <textarea
                class="rounded-lg pl-2 pt-2 focus:outline-none ang-form-control"
                rows="9"
                name="comment"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row mt-3" v-if="consents">
          <div class="col-md-12 text-justify">
            <div class="form-group form-check">
              <input
                type="checkbox"
                class="form-check-input"
                :name="'consents[lead][check]'"
                value="1"
                :required="true"
              />
              <label class="form-check-label ang-consent"
                ><span class="mr-1">*</span
                ><span
                  >Oświadczam, że pozyskałam/em zgodę ww. klienta na
                  udostępnienie jego danych osobowych do ANG Odpowiedzialne
                  Finanse S.A. z siedzibą w Warszawie.</span
                ></label
              >
            </div>
            <div>
              Administratorem danych osobowych jest ANG Odpowiedzialne Finanse
              S.A. z siedzibą w Warszawie. Dane osobowe pośrednika są
              przetwarzane w celu weryfikacji prawidłowości i podstawy prawnej
              przekazania kontaktu do klienta oraz ustalenia, dochodzenia lub
              obrony roszczeń. Pośrednik ma w szczególności prawo dostępu do
              danych, ich sprostowania lub usunięcia. Szczegółowe informacje o
              przetwarzaniu danych i przysługujących prawach są dostępne w
              <a
                href="https://angfinanse.pl/polityka-prywatnosci/"
                target="_blank"
                >Polityce prywatności.</a
              >
            </div>
          </div>
        </div>
        <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
          <h5 class="ang-card-title">Wystąpił błąd!</h5>
          <label class="form-error error">{{ error }}</label>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <spinner v-if="sending"></spinner>
            <button
              v-else
              type="submit"
              class="btn btn-lg ang-button ang-btn-lg spinn"
            >
              Wyślij
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
import spinner from "@/components/partials/misc/spinner";
import $ from "jquery";

export default {
  data() {
    return {
      consents: [],
      error: null,
      sending: false,
      sent: false,
      loading: false,
      // biznes: false,
      step: this.base && this.base.length > 0 ? 2 : 1,
    };
  },
  components: {
    spinner,
  },
  name: "angForm",
  mounted() {
    let self = this;
    this.$nextTick(function () {
      // self.scrollToAnchor("platformaMieszkaniowaLeadFormHeader");
      ajax.postValidate(
        $(self.$refs.platformaMieszkaniowaLeadForm),
        self,
        function () {
          self.sent = 1;
          self.sending = false;
        },
        function (data) {
          self.error = data.message;
          self.sending = false;
          $("html,body").animate({ scrollTop: $(document).height() }, "slow");
        },
        function () {
          self.error = null;
          self.sending = true;
        }
      );
    });
  },

  methods: {
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
};
</script>
